import { render, staticRenderFns } from "./StatisticsGrossProfit.vue?vue&type=template&id=3ea67d13&"
import script from "./StatisticsGrossProfit.vue?vue&type=script&lang=js&"
export * from "./StatisticsGrossProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports